// extracted by mini-css-extract-plugin
module.exports = {"cp-login":"styles_cp-login__13umI","button":"styles_button__3naqb"};